export default __webpack_public_path__ + "static/media/reactlofi.b233703e.PNG";